import React, {useEffect, useRef, useState} from 'react';
import {FormattedMessage} from "react-intl";

import SidebarItem from "../../../../../../SidebarItem";

import {ReactComponent as DocumentDownload} from "assets/img/document-download-contained.svg";

function DownloadAppItem(props) {
    const timeoutRef = useRef(null);
    const [active, setActive] = useState(false)

    useEffect(() => {
        verifyIfInstallPromptIsReady();

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [])

    function verifyIfInstallPromptIsReady() {
        let isActive = !!window.installWishibamApplicationPrompt;

        if (!isActive) {
            timeoutRef.current = setTimeout(() => verifyIfInstallPromptIsReady(), 1000);
        } else {
            setActive(true);
        }
    }

    if (active === false) {
        return null;
    }

    return (
        <SidebarItem
            isTopLevel={true}
            icon={<DocumentDownload />}
            onClick={() => {
                if (window.installWishibamApplicationPrompt) {
                    window.installWishibamApplicationPrompt.prompt();
                    window.installWishibamApplicationPrompt.userChoice.then((choiceResult) => {
                        if (timeoutRef.current) {
                            clearTimeout(timeoutRef.current);
                        }
                        if (choiceResult.outcome === 'accepted') {
                            window.installWishibamApplicationPrompt = null;
                            setActive(false)
                        } else {
                            // User did not accept the installation of the app.
                        }
                    });
                }
            }}
        >
            <FormattedMessage id='sidebar.profil.setting.menu.downloadApp' />
        </SidebarItem>
    );
}

export default DownloadAppItem;
